import React, { useState } from 'react'

import Field from './Field'
import URLAttributeInput from './URLAttributeInput'
import { Container, Form } from './styles'

function SocialMediaForm({ formik, removeUrls, onChangeRemoveURLs }) {
  const [editableFields, setEditableFields] = useState({})

  const handleSwitchChange = switchId => {
    setEditableFields(prevState => ({
      ...prevState,
      [switchId]: !editableFields[switchId],
    }))
  }

  const defaultProps = {
    onSwitchChange: handleSwitchChange,
    editableFields: editableFields,
    controller: formik,
  }

  return (
    <Container>
      <Form>
        <Field
          {...defaultProps}
          name="attributes/url_facebook"
          label="Facebook"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />

        <Field
          {...defaultProps}
          name="attributes/url_instagram"
          label="Instagram"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />

        <Field
          {...defaultProps}
          name="attributes/url_linkedin"
          label="Linkedin"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />

        <Field
          {...defaultProps}
          name="attributes/url_pinterest"
          label="Pinterest"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />

        <Field
          {...defaultProps}
          name="attributes/url_tiktok"
          label="Tiktok"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />

        <Field
          {...defaultProps}
          name="attributes/url_twitter"
          label="X (Twitter)"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />

        <Field
          {...defaultProps}
          name="attributes/url_youtube"
          label="Youtube"
          removeUrls={removeUrls}
          onChangeRemoveURLs={onChangeRemoveURLs}
          render={URLAttributeInput}
          valueExtractor={v => v}
        />
      </Form>
    </Container>
  )
}

export default SocialMediaForm
